import { cva } from 'class-variance-authority'

export const pagination = cva(['flex items-center gap-2 ml-auto'])
